import { AttensiToast } from '@attensi/materia'
import { createApp } from 'vue'

export const toast = (messageParams: unknown, optionsParams: unknown) => {
  /**
   * Create element for toast to mount
   */
  const elem = document.createElement('div')
  if (document.body) {
    document.body.appendChild(elem)
  }

  /**
   * Create and mount app for toast
   */
  createApp(AttensiToast, {
    messageParams,
    optionsParams,
    mountingElement: elem,
  }).mount(elem)
}
